angular.module('assets')
    .component('documentTagIco', {
        bindings: {
            tag: '<?'
        },
        template: `
            <span ng-switch="$ctrl.tag" title="{{ 'asset-doc.tag.'.concat($ctrl.tag) | translate }}">
                <span ng-switch-when="PROJECT"><i class="fa fa-fw fa-mail-forward text-primary"></i></span>
                <span ng-switch-when="SERVICE"><i class="fa fa-fw fa-wrench text-warning"></i></span>
                <span ng-switch-when="PURCHASE"><i class="fa fa-fw fa-shopping-cart text-success"></i></span>
                <span ng-switch-when="RENT"><i class="fa fa-fw fa-file-text text-success"></i></span>
                <span ng-switch-when="RETURN"><i class="fa fa-fw fa-reply text-danger"></i></span>
                <span ng-switch-when="SELL"><i class="fa fa-fw fa-shopping-basket text-danger"></i></span>
                <span ng-switch-when="DAMAGE"><i class="fa fa-fw fa-trash text-danger"></i></span>
                <span ng-switch-default></span>
            </span>
        `
    })
